export const state = {
  resources: [],
  favoriteResourcesIds: [],
  selectedResourceId: '',
  selectedResourceCategory: '',
  shouldRefreshResources: false,
}

export const getters = {
  allResources(state) {
    return state.resources
  },
  favoriteResources(state) {
    return state.resources.filter((resource) => resource.isFavorite)
  },
  selectedResourceId(state) {
    return state.selectedResourceId
  },
  selectedResourceCategory(state) {
    return state.selectedResourceCategory
  },
  favoriteResourcesIds(state) {
    return state.favoriteResourcesIds
  },
  isResourceFavorite(state, getters) {
    return (resourceId) => {
      return (
        getters.favoriteResources.some((resource) => resource.resourceId === resourceId) ||
        getters.favoriteResourcesIds.includes(resourceId)
      )
    }
  },
  shouldReloadResources(state) {
    return state.shouldRefreshResources
  },
}

export const mutations = {
  SET_RESOURCES(state, resources) {
    state.resources = resources
    const favoriteResourcesIds = resources
      .filter((resource) => resource.isFavorite)
      .map((resource) => resource.resourceId)
    state.favoriteResourcesIds = []
    favoriteResourcesIds.forEach((resourceId) => state.favoriteResourcesIds.push(resourceId))
  },

  FAVORITE_RESOURCE_BY_ID(state, resourceId) {
    const resourceToBeFavorite = state.resources.find((resource) => resource.resourceId === resourceId)
    if (resourceToBeFavorite) {
      resourceToBeFavorite.isFavorite = true
      resourceToBeFavorite.favoritedAt = new Date().toISOString()
    }

    state.favoriteResourcesIds = [...state.favoriteResourcesIds, resourceId]
  },

  UNFAVORITE_RESOURCE_BY_ID(state, resourceId) {
    const resourceToBeUnfavorite = state.resources.find((resource) => resource.resourceId === resourceId)
    if (resourceToBeUnfavorite) {
      resourceToBeUnfavorite.isFavorite = false
      resourceToBeUnfavorite.favoritedAt = null
    }

    state.favoriteResourcesIds = state.favoriteResourcesIds.filter((id) => id !== resourceId)
  },

  ADD_RESOURCE_ID_TO_FAVORITE_IDS(state, resourceId) {
    state.favoriteResourcesIds = [...state.favoriteResourcesIds, resourceId]
  },

  REMOVE_RESOURCE_ID_TO_FAVORITE_IDS(state, resourceId) {
    state.favoriteResourcesIds = state.favoriteResourcesIds.filter((id) => id !== resourceId)
  },

  SET_SELECTED_RESOURCE_ID(state, resourceId) {
    state.selectedResourceId = resourceId
  },

  SET_SELECTED_RESOURCE_CATEGORY(state, categoryName) {
    state.selectedResourceCategory = categoryName
  },

  SET_SHOULD_RELOAD_RESOURCES(state, bool) {
    state.shouldRefreshResources = bool
  },
}
